<ng-container *ngIf="startForm">
  <div class="card mb-4">
    <div class="card-body">
      <ng-container *ngIf="!existeCliente; else existeText">
        <h5 class="fs-4 fw-bold card-title mb-4">Comencemos</h5>
        <form [formGroup]="startForm">
          <div class="mb-3">
            <p class="fs-6 mb-3">¿Cuál es tu DNI o NIE?</p>
            <label class="fw-bold" for="dniNie">DNI/NIE: </label>
            <input
              autocomplete="off"
              placeholder="Ingrese su DNI o NIE"
              formControlName="dniNie"
              maxlength="11"
              class="form-control is-valid"
              [ngClass]="{
                'is-valid': startForm.controls.dniNie.status === 'VALID',
                'is-invalid':
                  startForm.controls.dniNie.errors &&
                  (startForm.controls.dniNie.dirty || startForm.controls.dniNie.touched)
              }"
            />
            <small class="error" *ngIf="!startForm.valid && startForm.touched"> DNI/NIE incorrecto </small>
          </div>
        </form>
      </ng-container>
      <ng-template #existeText>
        <h5 class="fs-4 fw-bold card-title mb-4">Comencemos</h5>
        <p>
          Vemos que ya te has registrado en nuestra plataforma. Vamos a enviarte un código de verificación para
          confirmar que eres tú.
        </p>
      </ng-template>

      @if(!existeCliente){
      <ngx-recaptcha2
        [siteKey]="sitekey"
        [size]="size"
        [hl]="lang"
        [theme]="theme"
        [type]="type"
        (success)="handleCaptchaSuccess($event)"
        (expire)="handleCaptchaExpired()"
      >
      </ngx-recaptcha2>
      }
    </div>
  </div>
  <app-button
    *ngIf="!existeCliente"
    [disabled]="!startForm.valid || !captchaValidated()"
    (clicked)="onSubmit()"
    [loading]="loading"
  >
    Continuar
  </app-button>
  <ng-container *ngIf="existeCliente">
    <app-button (clicked)="sendCode('EMAIL')" [loading]="loading">
      Enviar código a mi <strong>correo electrónico</strong>
    </app-button>
  </ng-container>
</ng-container>
